import _implicitStylesheets from "./popoverTooltip.css";
import _implicitScopedStylesheets from "./popoverTooltip.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _i18nLink from "i18n/link";
import _wdsBadge from "wds/badge";
import _wdsLinkWithIcon from "wds/linkWithIcon";
import _wdsPopover from "wds/popover";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="titled-section${0}"${2}><p class="titled-section__title${0}" type-style="body-3" role="heading" aria-level="3"${2}><strong${3}>${"t3"}</strong></p><p class="titled-section__description${0}" type-style="body-3"${2}>${"t5"}</p></div>`;
const stc0 = {
  classMap: {
    "tooltip": true
  },
  key: 0
};
const stc1 = {
  "tooltip-button": true,
  "popover-trigger": true
};
const stc2 = {
  props: {
    "icon": "info",
    "size": "small",
    "ariaHidden": "true"
  },
  key: 2
};
const stc3 = {
  classMap: {
    "popover-content": true
  },
  attrs: {
    "data-testid": "popover-content"
  },
  key: 4
};
const stc4 = [];
const stc5 = {
  classMap: {
    "text-container": true
  },
  key: 7
};
const stc6 = {
  "tooltip-text": true
};
const stc7 = {
  classMap: {
    "badge-container": true
  },
  key: 10
};
const stc8 = {
  classMap: {
    "content-container": true
  },
  key: 12
};
const stc9 = {
  classMap: {
    "description-container": true
  },
  attrs: {
    "type-style": "body-3"
  },
  key: 13
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, b: api_bind, c: api_custom_element, h: api_element, k: api_key, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, i: api_iterator, ncls: api_normalize_class_name, f: api_flatten} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_element("div", stc0, [api_element("button", {
    classMap: stc1,
    attrs: {
      "data-popover-trigger": "",
      "variant": "tertiary",
      "size": "ultrasmall",
      "tabindex": "0",
      "aria-label": $cmp.ariaMoreInfo,
      "aria-controls": api_scoped_id("tooltip-container"),
      "aria-expanded": $cmp.ariaExpanded,
      "aria-haspopup": "dialog"
    },
    key: 1,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.togglePopover))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc2)]), api_custom_element("wds-popover", _wdsPopover, {
    props: {
      "show": $cmp.showPopover,
      "id": api_scoped_id("tooltip-container"),
      "ariaLabel": $cmp.popoverAriaLabel,
      "popoverOrientation": $cmp.orientation,
      "flipIfOverflowsViewport": $cmp.flipIfOverflowsViewport,
      "focusContainerOnOpen": true
    },
    key: 3,
    on: {
      "close": _m1 || ($ctx._m1 = api_bind($cmp.closePopover)),
      "keydown": _m2 || ($ctx._m2 = api_bind($cmp.handleInputKey))
    }
  }, [api_element("div", stc3, api_flatten([$cmp.hasTitledSections ? api_iterator($cmp.titledSections, function (section) {
    return api_static_fragment($fragment1, api_key(6, section.key), [api_static_part(3, null, api_dynamic_text(section.title)), api_static_part(5, null, api_dynamic_text(section.description))]);
  }) : stc4, !$cmp.hasTitledSections ? api_flatten([$cmp.isTextTooltip ? api_element("div", stc5, [api_custom_element("i18n-link", _i18nLink, {
    classMap: stc6,
    props: {
      "message": $cmp.tooltipData,
      "target": "_blank"
    },
    key: 8
  })]) : null, !$cmp.isTextTooltip ? api_iterator($cmp.tooltipData, function (itValue, itIndex, itFirst, itLast) {
    const it = {
      value: itValue,
      index: itIndex,
      first: itFirst,
      last: itLast
    };
    return api_element("div", {
      className: api_normalize_class_name($cmp.popoverLayoutStyle),
      key: api_key(9, it.value.badge.iteratorKey)
    }, [api_element("div", stc7, [api_custom_element("wds-badge", _wdsBadge, {
      props: {
        "badge": it.value.badge
      },
      key: 11
    })]), api_element("div", stc8, [api_element("div", stc9, [api_custom_element("i18n-link", _i18nLink, {
      props: {
        "message": it.value.description
      },
      key: 14
    })]), it.value.link ? api_custom_element("wds-link-with-icon", _wdsLinkWithIcon, {
      props: {
        "caption": it.value.link.caption,
        "icon": it.value.link.icon,
        "url": it.value.link.url
      },
      key: 15
    }) : null])]);
  }) : stc4]) : stc4]))])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1ik9ckj1qua";
tmpl.legacyStylesheetToken = "undefined-_popoverTooltip";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
